import { Services } from "../../services/Services.js";
import { Control } from "../Control.js";

class GridCell extends Control {

    constructor(parent, options = {}) {

        options = Object.assign({
            width: 12,
            controls: []
        }, options || {});

        super(parent, options);

        const {
            width = 12,
            controls = [],
        } = options;

        this.width = width;
        this.controls = controls;
        this.controls.forEach((control) => control.parent = this);

    };

    render(vm) {

        const templates = Services.get('templates');

        var props = {},
            style = (templates.cw(this.width) || '') + (this.getCss() || ''),
            controls = this.controls.map(function (control) {
                if (!control)
                    return null;
                return control.render(vm);
            });

        return templates.cell(style, props, controls);

    };

}

export class Grid extends Control {

    constructor(parent, options = {}) {

        options = Object.assign({
            width: null,
            cells: []
        }, options || {});

        super(parent, options);

        this.width = options.width;
        this.cells = options.cells;

        return this;

    };

    cell(options) {

        options = options || {};

        this.cells.push(new GridCell(this, options));
        return this;

    };

    render(vm) {

        const templates = Services.get('templates');

        var props = {
            vertical: this.vertical,
            visible: this.isVisible(),
        },
            style = (templates.width(this.width) || '') + (this.getCss() || ''),
            controls = this.cells.map(function (cell) {
                if (!cell)
                    return null;
                return cell.render(vm);
            });

        return templates.grid(style, props, controls);

    };

}